import * as actionTypes from './addon-types';

const INITIAL_STATE = {
    addonsList: [],
    isLoaded: false,
    strawsList: []
}

const addonsReducer = (state = INITIAL_STATE, action) => {
    let { addonsList, strawsList, isLoaded } = state;
    
    switch(action.type) {
        case actionTypes.ADDON_LIST:
            addonsList = action.payload.data;
            isLoaded = addonsList.length > 0;

            return {
                ...state,
                addonsList,
                isLoaded
            };
        case actionTypes.STRAW_LIST:
            strawsList = action.payload.data.map((item, index) => {
                return {
                    ...item,
                    addon_name: item.straw_name
                }
            });
            isLoaded = strawsList.length > 0;

            return {
                ...state,
                strawsList,
                isLoaded
            };
        default: 
            return state;
    }
};

export default addonsReducer;